var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('roles.pageTitle'),"description":_vm.$t('roles.pageSubtitle'),"to":{ name: _vm.RouteName.Moderation }}},[_c('RolesManagement')],1)}
var staticRenderFns = []

export { render, staticRenderFns }